import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const LoyaltyProgramBannerWrapper = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: #f0f2f8;

  svg {
    flex: 0 0 auto;
  }
`;

export const CtaLink = styled.a`
  display: inline-block;
  ${theme.typography.labelSmall}
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  span {
    flex: 2;
    min-width: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    span {
      flex: 3;
    }
  }
`;

export const LoyaltyButton = styled.button`
  background: none;
  border: none;
  text-decoration: underline;
  flex: 0 0 auto;
  cursor: pointer;
  min-width: 0;

  @media (min-width: ${breakpoints.md}) {
    flex: 0 0 auto;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
  }

  ${theme.typography.bodyRegular}
  color: ${theme.color.text.primary};
  font-weight: 500;
`;
